import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Set initial time to 23h 59m 48s in seconds
  const initialTime = 23 * 3600 + 59 * 60 + 48;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-display font-bold text-coral" data-id="element-284">
      <div className="flex flex-col items-center" data-id="element-285">
        <span className="bg-white px-3 py-2 rounded-lg shadow-sm border border-cream-dark min-w-[60px] text-center" data-id="element-286">
          {formatTime(hours)}
        </span>
        <span className="text-xs text-dark-light mt-1 uppercase tracking-wider" data-id="element-287">
          horas
        </span>
      </div>
      <span className="text-dark pb-6" data-id="element-288">:</span>
      <div className="flex flex-col items-center" data-id="element-289">
        <span className="bg-white px-3 py-2 rounded-lg shadow-sm border border-cream-dark min-w-[60px] text-center" data-id="element-290">
          {formatTime(minutes)}
        </span>
        <span className="text-xs text-dark-light mt-1 uppercase tracking-wider" data-id="element-291">
          minutos
        </span>
      </div>
      <span className="text-dark pb-6" data-id="element-292">:</span>
      <div className="flex flex-col items-center" data-id="element-293">
        <span className="bg-white px-3 py-2 rounded-lg shadow-sm border border-cream-dark min-w-[60px] text-center" data-id="element-294">
          {formatTime(seconds)}
        </span>
        <span className="text-xs text-dark-light mt-1 uppercase tracking-wider" data-id="element-295">
          seg
        </span>
      </div>
    </div>;
}